import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation updateEvent($id: String!, $name: String!, $description: String, $location: String, $startDate: String!, $endDate: String, $imageId: String) {
    updateEvent( groupEventId: $id, name: $name, description: $description, location: $location, startDate: $startDate, endDate: $endDate, image: $imageId) {
      success
      message
    }
  }
`

export interface UpdateEventInput {
  id: string
  name: string
  description?: string
  location?: string
  startDate: string
  endDate?: string
}

export interface UpdateEventOutput {
  updateEvent: {
    success: boolean
    message: string
  }
}

export const useUpdateEvent = () => useMutation<UpdateEventOutput, UpdateEventInput>(mutation)
